import React, { useState } from 'react';
import { billingService } from '../services/billing';
import { User } from '../types';

interface TrialEndedScreenProps {
  user: User;
}

const TrialEndedScreen: React.FC<TrialEndedScreenProps> = ({ user }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const startSubscription = async () => {
    setIsLoading(true);
    setError('');
    try {
      await billingService.redirectToCheckout(user.id);
    } catch (checkoutError) {
      setError(checkoutError instanceof Error ? checkoutError.message : 'Could not open subscription checkout.');
      setIsLoading(false);
    }
  };

  const endedDate = user.trialEndsAt
    ? new Date(user.trialEndsAt).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : null;

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 sm:p-10 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-orange-100 text-orange-700 text-2xl font-bold">
          !
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Your free trial has ended</h1>
        <p className="mt-3 text-gray-600">
          {endedDate
            ? `Your full Serprocket access ended on ${endedDate}.`
            : 'Your full Serprocket trial access has ended.'}
          {' '}Choose a subscription to continue using the dashboard and SEO tools.
        </p>
        <button
          type="button"
          onClick={startSubscription}
          disabled={isLoading}
          className="mt-7 inline-flex items-center justify-center rounded-md bg-gradient-to-r from-orange-400 to-pink-600 px-6 py-3 font-semibold text-white transition hover:from-orange-500 hover:to-pink-700 disabled:cursor-wait disabled:opacity-60"
        >
          {isLoading ? 'Opening secure checkout…' : 'Purchase a subscription'}
        </button>
        {error && <p role="alert" className="mt-4 text-sm text-red-700">{error}</p>}
        <p className="mt-4 text-xs text-gray-500">Secure subscription checkout is handled by Stripe.</p>
      </div>
    </div>
  );
};

export default TrialEndedScreen;
